__turbopack_context__.v({
  "g2k": "GoodToKnow-module-scss-module__N7vG8W__g2k",
});
